<template>
  <div class="skeleton-loader">
    <div class="row g-2 g-md-3 mb-3">
      <div class="col-6 col-md-4 col-lg-3">
        <div class="square shimmer"></div>
        <div class="p-3">
          <div class="row g-0 mb-1">
            <div class="col-7">
              <div class="shimmer w-100" style="height: 21px"></div>
            </div>
            <div class="col-2"></div>
            <div class="col-3">
              <div class="shimmer w-100" style="height: 21px"></div>
            </div>
          </div>
          <div class="row g-0 mb-2">
            <div class="col-5">
              <div class="shimmer w-100" style="height: 18.38px"></div>
            </div>
          </div>
          <div class="row g-0 mb-1">
            <div class="col-4">
              <div class="shimmer w-100" style="height: 21px"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 col-md-4 col-lg-3">
        <div class="square shimmer"></div>
        <div class="p-3">
          <div class="row g-0 mb-1">
            <div class="col-7">
              <div class="shimmer w-100" style="height: 21px"></div>
            </div>
            <div class="col-2"></div>
            <div class="col-3">
              <div class="shimmer w-100" style="height: 21px"></div>
            </div>
          </div>
          <div class="row g-0 mb-2">
            <div class="col-5">
              <div class="shimmer w-100" style="height: 18.38px"></div>
            </div>
          </div>
          <div class="row g-0 mb-1">
            <div class="col-4">
              <div class="shimmer w-100" style="height: 21px"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 col-md-4 col-lg-3">
        <div class="square shimmer"></div>
        <div class="p-3">
          <div class="row g-0 mb-1">
            <div class="col-7">
              <div class="shimmer w-100" style="height: 21px"></div>
            </div>
            <div class="col-2"></div>
            <div class="col-3">
              <div class="shimmer w-100" style="height: 21px"></div>
            </div>
          </div>
          <div class="row g-0 mb-2">
            <div class="col-5">
              <div class="shimmer w-100" style="height: 18.38px"></div>
            </div>
          </div>
          <div class="row g-0 mb-1">
            <div class="col-4">
              <div class="shimmer w-100" style="height: 21px"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 col-md-4 col-lg-3">
        <div class="square shimmer"></div>
        <div class="p-3">
          <div class="row g-0 mb-1">
            <div class="col-7">
              <div class="shimmer w-100" style="height: 21px"></div>
            </div>
            <div class="col-2"></div>
            <div class="col-3">
              <div class="shimmer w-100" style="height: 21px"></div>
            </div>
          </div>
          <div class="row g-0 mb-2">
            <div class="col-5">
              <div class="shimmer w-100" style="height: 18.38px"></div>
            </div>
          </div>
          <div class="row g-0 mb-1">
            <div class="col-4">
              <div class="shimmer w-100" style="height: 21px"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UnitSkeletonLoader",
};
</script>
